import { render, staticRenderFns } from "./order-type-list.vue?vue&type=template&id=7fff76f6&scoped=true"
import script from "./order-type-list.vue?vue&type=script&lang=js"
export * from "./order-type-list.vue?vue&type=script&lang=js"
import style0 from "./order-type-list.vue?vue&type=style&index=0&id=7fff76f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fff76f6",
  null
  
)

export default component.exports